<template>
  <div class="login">
    <div class="login__top">
      <span class="login__close" @click="closeModal" />
    </div>
  <span class="login__alert">{{text}}</span>
  <div
    class="login__email-button"
    v-if="text==='Zweryfikuj swój adres e-mail aby kontynuować.'"
  >
    <SelectButton buttonName="Wyślij ponownie e-mail aktywacyjny" :action="sendEmailAgain" />
  </div>
    <div class="login__buttons">
      <SelectButton buttonName="OK" :action="closeModal" />

    </div>
  </div>
</template>

<script>
import SelectButton from "@/ui/SelectButton.vue";
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SelectButton,
  },
  computed: {
      text() {
          return this.$store.state.genericModalText
      }
  }
};
</script>

<style scoped lang="scss">
.login {
  width: 31.875rem;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &__buttons {
    width: 28%;
  }

  &__top {
    height: 3rem;
    width: 100%;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    position: relative;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &__alert {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    font-weight: 700;
  }
  &__close {
    color: #fff;
    font-size: 30px;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    width: 1.25rem;
    height: 1.25rem;
    display: block;
    background-image: url("~@/assets/loginModal__close.png");
    background-size: cover;
    background-position: center;
  }

  &__flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 66%;
    font-family: "Poppins", sans-serif;
    color: #5e5a6b;
    font-style: italic;
  }
  &__email-button {
    width: 20rem;
  }
  .flex {


    &__label {
      margin-left: 0.5rem;
      &:hover {
        cursor: pointer;
      }
    }
  }

  &__cancel {
    width: 100%;
    height: 2.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    border: none;
    border-radius: 5px;
    color: #0f1626;
    letter-spacing: 0.8px;
    margin-bottom: 1rem;

    background-color: transparent;
    cursor: pointer;
    &:hover {
      background-color: darken(#fff, 10%);
    }
  }
}
</style>
